import Icon from '../components/Icon.vue'

Icon.register({
  'unlock-alt': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 256H152V152.9C152 113.3 183.7 80.4 223.3 80 263.3 79.6 296 112.1 296 152V168C296 181.3 306.7 192 320 192H352C365.3 192 376 181.3 376 168V152C376 68 307.5-0.3 223.5 0 139.5 0.3 72 69.5 72 153.5V256H48C21.5 256 0 277.5 0 304V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V304C448 277.5 426.5 256 400 256zM264 408C264 430.1 246.1 448 224 448S184 430.1 184 408V360C184 337.9 201.9 320 224 320S264 337.9 264 360V408z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/unlock-alt.js
// module id = 7g/a
// module chunks = 144